import * as React from 'react';
import { TextField, IconButton, InputLabel, FormHelperText } from '@mui/material';
import { FileUploadOutlined } from "@mui/icons-material";
import { TypingValidateNumber } from '../../../util/General';

export const ContactNumber = ({ id, value, updateValue, path, description, errors, visible, label }) => {
  // console.log('value', value)
  const [validationError, setValidationError] = React.useState('')
  const [touched, setTouched] = React.useState(false)

  const handleChange = (event) => {
    let initialValue = event.target.value;
    if (initialValue.match(/[^0-9+\s]/gi)) {
      return;
    }
    const data = TypingValidateNumber(initialValue);
    updateValue({ value: data?.intl_number ? data.intl_number : data?.org_number, is_valid: data.is_valid });
    if (!data.is_valid) {
      setValidationError('Not a valid phone/mobile number')
    } else {
      setValidationError('')
    }
  };

  const handleTouch = () => {
    setTouched(true);
  };

  const handleTouchOut = () => {
    setTouched(false);
  };

  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      <TextField
        variant="standard"
        type="text"
        value={value?.value ?? ''}
        fullWidth={true}
        style={{ marginBottom: errors ? '0px' : undefined }}
        error={errors || validationError ? true : false}
        label={label}
        helperText={validationError ? validationError : touched && description}
        onChange={handleChange}
        onFocus={handleTouch}
        onBlur={handleTouchOut}
      />
      { errors &&
        <FormHelperText error={true} filled={true}>{errors}</FormHelperText>
      }
    </div>
  );
};
